import BrandCard from "components/main-view/utils/cards/BrandCard";
import EmptyView from "components/main-view/utils/components/EmptyView";
import { BrandListType } from "utils/interfaces";
import { LoadingDots } from "utils/loadingAnimation";

interface RootAdminDashboardListProps {
  data: BrandListType[];
  searchQuery: string;
  isLoadingData: boolean;
  handleClickEdit: (card: BrandListType) => (event: React.MouseEvent) => void;
  onCreateEditBrand: (title?: string, description?: string) => void;
}

const RootAdminDashboardList: React.FC<RootAdminDashboardListProps> = ({
  data,
  searchQuery,
  isLoadingData,
  handleClickEdit,
  onCreateEditBrand,
}) => {
  /**
   * Function that renders the list of cards depending of the activeClass selected
   * @returns a list of cards
   */
  const cardsToRender = () => {
    return data && data.length > 0 ? (
      data
        .filter((item: BrandListType) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .map((brand: BrandListType, index: number) => (
          <BrandCard
            key={index}
            brand={brand}
            // handleClickEdit={handleClickEdit(brand)}
          />
        ))
    ) : !isLoadingData ? (
      <EmptyView
        showCreateNew={true}
        onCreateNewClick={() => onCreateEditBrand()}
      />
    ) : (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingDots bgColor="bg-neutral-300" />
      </div>
    );
  };

  return (
    <div className="w-full h-full flex-col justify-start items-start gap-4 inline-flex overflow-y-auto custom-scroll">
      {cardsToRender()}
    </div>
  );
};

export default RootAdminDashboardList;
